import {ReactRouterDomAdapter} from '@vizir-banking/banking-app-core/dist/navigation/adapters/react-router-dom-adapter';

export const NavigationAdapter = ReactRouterDomAdapter;
